import { useState } from "react";
import { useNavigate } from "react-router-dom";

// import CreditCardIcon from "@mui/icons-material/CreditCard";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Button, Chip, DialogActions, DialogContent, Paper, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import Tooltip from "@mui/material/Tooltip";
import { siteName } from "@/constants/config";
import usePlatform from "@/hooks/usePlatform";
import useThemeData from "@/hooks/useThemeData";

const PriceGuarantee = () => {
  const bgBlack = "https://img.awardtool.com/guides/website-img/flights-deals-origin-bg-black.jpg";
  const bgWhite = "https://img.awardtool.com/guides/website-img/flights-deals-origin-bg-white.jpg";

  const theme = useThemeData();
  const { isPc } = usePlatform();

  const [visible, setVisible] = useState(false);

  const navigate = useNavigate();

  return (
    <Paper
      elevation={1}
      className="!rounded-[4px]"
      style={{
        backgroundColor: theme.isDarkMode ? "#202124" : "#f1f3fb",
        marginLeft: "10px",
        marginRight: "10px",
      }}
    >
      <div className="flex items-center justify-between h-[70px]">
        <div className="pl-[20px] flex items-center">
          <div className="w-[30px] h-[30px] mr-[10px]">
            <LocalOfferOutlinedIcon color="primary" />
          </div>
          <div>
            <div className="flex items-center justify-between md:justify-start">
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="body1"
              >
                Award Flight Deal Explorer
              </Typography>

              {/* <Button
                size="small"
                variant="outlined"
                className="!ml-[15px]"
                onClick={() => navigate("/all-routes")}
              >
                All Routes
              </Button> */}
            </div>
            <Typography className="flex items-center">
              {isPc
                ? "Explore the world with the best deals among millions of award flights."
                : "Explore the world with the best deals."}
              <Tooltip
                sx={{ size: 10 }}
                title={"Millions of flights are checked by " + siteName + " to find the best deals for you to explore the world. Airline inventory and prices can change quickly especially for the best deals.  Prices include required points + taxes for 1 adult. Optional charges and bag fees may apply."}
              >
                <InfoOutlinedIcon
                  onClick={() => {
                    if (!isPc) {
                      setVisible(true);
                    }
                  }}
                  sx={{ fontSize: 16, margin: "auto" }}
                />
              </Tooltip>
            </Typography>
          </div>
        </div>

        {isPc && <img className="h-[100%]" src={theme.isDarkMode ? bgBlack : bgWhite} alt="" />}

        <Dialog
          open={visible}
          onClose={() => setVisible(false)}
          PaperProps={{
            sx: {
              borderRadius: "12px",
            },
          }}
        >
          <DialogContent>
            <Typography fontSize={16}>
              {"Millions of flights are checked by " + siteName + " to find the best deals for you to explore the world. Airline inventory and prices can change quickly especially for the best deals.  Prices include required points + taxes for 1 adult. Optional charges and bag fees may apply."}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setVisible(false)}>OK</Button>
          </DialogActions>
        </Dialog>
      </div>
    </Paper>
  );
};

export default PriceGuarantee;
